// extracted by mini-css-extract-plugin
export var calendarView = "_mx-0";